import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CategorylistComponent } from './components/categorylist/categorylist.component';
import { CreateSurvyComponent } from './components/create-survy/create-survy.component';
import { TemplateComponent } from './components/template/template.component';

const routes: Routes = [{
  path: '',
  component: CategorylistComponent
},
{
  path: 'templates/:id',
  component: TemplateComponent
},
{

  path: ':token',
  component: CategorylistComponent

},
{
  path: ':survey/:token',
  component: CreateSurvyComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
